var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogosFirebase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 141,
    viewBox: "0 0 103 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logos:firebase",
    clipPath: "url(#clip0_5_45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 113.683L0.854176 112.489L41.2511 35.9578L41.3364 35.1475L23.5291 1.75059C22.0364 -1.04691 17.8359 -0.339504 17.3466 2.79222L0 113.683Z",
    fill: "#FFC24A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0.50415 112.773L1.14991 111.515L41.124 35.7855L23.3605 2.2528C21.8843 -0.515376 18.1353 0.190427 17.6508 3.28921L0.50415 112.773Z",
    fill: "#FFA712"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3",
    filter: "url(#filter0_i_5_45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.50415 112.773L1.14991 111.515L41.124 35.7855L23.3605 2.2528C21.8843 -0.515376 18.1353 0.190427 17.6508 3.28921L0.50415 112.773Z",
    fill: "#FE6E00"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M54.3184 60.409L67.5777 46.8513L54.3144 21.5717C53.0555 19.1788 49.5402 19.1715 48.2945 21.5717L41.2081 35.064V36.2128L54.3184 60.409Z",
    fill: "#F4BD62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M54.0819 59.8443L66.9726 46.6634L54.0819 22.1563C52.8579 19.83 49.8842 19.5862 48.6732 21.9193L41.5497 35.6212L41.3364 36.3218L54.0819 59.8443Z",
    fill: "#FFA50E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_6",
    filter: "url(#filter1_i_5_45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.0819 59.8443L66.9726 46.6634L54.0819 22.1563C52.8579 19.83 49.8842 19.5862 48.6732 21.9193L41.5497 35.6212L41.3364 36.3218L54.0819 59.8443Z",
    fill: "#FE6E00"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M0 113.683L0.387055 113.294L1.79365 112.724L53.4856 61.3048L54.1406 59.5248L41.2455 34.9908L0 113.683Z",
    fill: "#F6820C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M55.9745 139.614L102.757 113.565L89.3976 31.4172C88.9795 28.8471 85.8215 27.8312 83.9788 29.6738L0 113.683L46.5142 139.612C47.9599 140.418 49.5882 140.842 51.244 140.842C52.8999 140.842 54.5283 140.42 55.9745 139.614Z",
    fill: "#FDE068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M102.338 113.346L89.0797 31.8227C88.6653 29.2718 86.0388 28.2165 84.2102 30.0455L0.519043 113.523L46.5226 139.196C47.9574 139.995 49.5732 140.415 51.2164 140.416C52.8597 140.416 54.4757 139.997 55.9109 139.198L102.338 113.346Z",
    fill: "#FCCA3F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M55.9741 138.847C54.528 139.652 52.8997 140.075 51.2439 140.074C49.5881 140.074 47.9599 139.651 46.5142 138.845L0.374607 113.288L0.000427246 113.683L46.5142 139.613C47.96 140.418 49.5882 140.842 51.2441 140.842C52.8999 140.842 54.5284 140.42 55.9745 139.615L102.757 113.565L102.642 112.861L55.9741 138.847Z",
    fill: "#EEAB37"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_5_45",
    x: 0.50415,
    y: 0.522827,
    width: 40.6198,
    height: 112.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_5_45"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_5_45",
    x: 41.3364,
    y: 13.2859,
    width: 26.6361,
    height: 46.5583,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: -9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_5_45"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_45"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 103,
    height: 141,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosFirebase);
export default __webpack_public_path__ + "static/media/logos-firebase.6b605399d21a210c4be1160562b49a34.svg";
export { ForwardRef as ReactComponent };